import React from 'react';

import { DataIndex } from 'Util/DataIndexUtils';
import { IGeneratedPlanFeedback } from 'Queries/Hooks/StudyPlan/types';
import { compareTwoDate } from 'Util/DateTimeUtils';
import { CourseSelectionItemProps }
	from 'Views/Pages/Frontend/StudyPlanWizard/CourseSelection/RequirementContainer/CourseSelectionItem';
import {
	RequirementNode,
} from 'Views/Pages/Frontend/StudyPlanWizard/RequirementTreeGeneration';
import RequirementContainer
	// eslint-disable-next-line max-len
	from 'Views/Pages/Frontend/StudyPlanWizard/CourseSelection/RequirementContainer/RequirementContainer';

interface IChildRequirementContainerProps {
	newDepth: number;
	childNodes: RequirementNode[];
	requisiteWarningsByCourseId: DataIndex<IGeneratedPlanFeedback['requisiteWarnings']>
	updatePlanSelections: CourseSelectionItemProps['updatePlanSelections']
}

const ChildRequirementList = ({
	childNodes,
	newDepth,
	requisiteWarningsByCourseId,
	updatePlanSelections,
}: IChildRequirementContainerProps) => {
	if (childNodes.length === 0) {
		return (
			<div className="empty-state">
				<p>No groups</p>
			</div>
		);
	}

	const sortedNodes = [...childNodes]
		.sort(
			(a, b) => compareTwoDate(
				new Date(a.requirement.created),
				new Date(b.requirement.created),
			),
		);

	return (
		<>
			{
				sortedNodes.map(childNode => (
					<RequirementContainer
						key={childNode.requirement.id}
						depth={newDepth}
						requirementSubtree={childNode}
						requisiteWarningsByCourseId={requisiteWarningsByCourseId}
						updatePlanSelections={updatePlanSelections}
					/>
				))
			}
		</>
	);
};

export default ChildRequirementList;
